<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9jUI9E/tc-custom/9781416592495.jpg?1730522511824" alt="This image is the cover for the book Women, Work & the Art of Savoir Faire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Women, Work & the Art of Savoir Faire
      </h1>
      <p class="bookDescription body article font2">
        <b>From the #1 <i>New York Times </i>bestselling “high priestess of French lady wisdom” (<i>USA Today</i>) comes every woman’s guide to navigating the world of work, living the good life, and savoring every minute of it.</b><br/><br/>Mireille Guiliano, internationally bestselling author of <i>French Women Don’t Get Fat</i> and former senior executive for Veuve Clicquot, uses her distinctive French woman’s philosophy and style to share lively lessons, stories, and helpful hints from her experiences at the front lines and highest echelons of the business world. Guiliano offers every reader the practical advice she needs to make the most of work without ever losing sight of what is most important: feeling good, facing challenges, getting ahead, and maximizing pleasure at every opportunity.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mireille Guiliano
      </h2>
      
      <p class="authorDescription body article">Mireille Guiliano is the bestselling author of <I>French Women Don't Get Fat,</I><I>French Women For All Seasons</I>, and <I>Women, Work &amp; the Art of Savoir Faire</I>.&#160; Born and raised in France, she is married to an American and lives most of the year in New York and Paris.&#160; She is the former&#160;President and CEO of Clicquot, Inc.&#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c285fb8